<template>
  <div>
    <v-row dense>
      <v-col cols='12'>
        <div class='mb-n3 subtitle-1'>Did you program the controller?</div>
        <v-radio-group :rules='[rules.required]' row v-model='controllerProgrammed' @change='update'>
          <v-radio value="The controller has been programmed.">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>
          <v-radio value="The controller has NOT been set.">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols='12'>
        <div class='mb-n3 subtitle-1'>Were you able to do the system show?</div>
        <v-radio-group :rules='[rules.required]' row v-model='showComplete' @change='update'>
          <v-radio value=" I was able to Show the System.">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>
          <v-radio value=" I was NOT able to do the System Show.">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols='12'>
        <div class='mb-n3 subtitle-1'>What type of site is this?</div>
        <v-radio-group :rules='[rules.required]' row v-model='siteType' @change='update'>
          <v-radio value="Dirt">
            <template v-slot:label>
              <div>Dirt</div>
            </template>
          </v-radio>
          <v-radio value="Grass">
            <template v-slot:label>
              <div>Grass</div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-expand-transition>
          <div v-if='siteType === "Dirt"'>
            <div class='mb-1 subtitle-1'>When are the landscapers laying sod?</div>
            <wc-datepicker
              label='earliest possible date'
              required
              v-model='sodDate'
            ></wc-datepicker>
          </div>
        </v-expand-transition>
      </v-col>
      <v-col cols='12'>
        <div class='subtitle-1'>Any other notes for the office?</div>
        <v-textarea
          outlined
          rows='1'
          auto-grow
          v-model='additionalNotes'
          @change='update'
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'fc-install-checks-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
  data: () => ({
    controllerProgrammed: undefined,
    showComplete: undefined,
    sodDate: "",
    siteType: "",
    additionalNotes: "",
  }),

  computed: {
    controllerProgrammedText() {
      return this.controllerProgrammed ? this.controllerProgrammed : ""
    },
    showCompleteText() {
      return this.showComplete ? this.showComplete : ""
    },
    siteTypeText() {
        return " This is a " + this.siteType + " Job. "
    },
    sodDateText () {
      if (this.siteType === "Dirt" && this.sodDate) {
        return " " + " Landscapers laying sod as early as " + this.$options.filters.shortDate(this.sodDate) + ". "
      }
      return ""
    },
    additionalNotesText () {
      if (this.additionalNotes) {
        return " " + " Additional Notes: " + this.additionalNotes + "."
      }
      return ""
    }
  },
  methods : {
    update() {
      this.$emit('input', this.controllerProgrammedText  + this.showCompleteText + this.siteTypeText + this.sodDateText + this.additionalNotesText)
    }
  },
  components: {
 
  }
}
</script>
